<template>
  <TabPanel class="h-full" :unmount="false">
    <transition name="tab-slide" mode="out-in" appear>
      <div class="tab-panel-wrapper overflow-auto p-4">
        <slot />
      </div>
    </transition>
  </TabPanel>
</template>

<script setup lang="ts">
import { TabPanel } from '@headlessui/vue';
</script>

<style scoped>
/* Slide transition for panel content */
.tab-slide-enter-active,
.tab-slide-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.tab-slide-enter-from {
  opacity: 0;
  transform: translateX(20px);
}

.tab-slide-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}

.tab-panel-wrapper {
  min-height: inherit;
}
</style>
